import { FC } from 'react'
import { Modal } from 'react-bootstrap'
import { KTIcon } from '../../../helpers'
import { NotificationListModal } from '../../widgets/lists/NotificationListModal'

type NotificationsModalProps = {
  open: boolean
  onClose: () => void
}

const NotificationsModal: FC<NotificationsModalProps> = ({ open, onClose }) => {
  return (
    <Modal
      show={open}
      onHide={onClose}
      centered
      size={'md' as any}
      backdropClassName="custom-backdrop"
      dialogClassName="custom-dialog"
    >
      <div className='modal-content' style={{ zIndex: 200000 }}>
        <div className='modal-header pb-0 border-0 justify-content-between'>
        <div
            className='btn btn-sm btn-icon btn-active-color-primary'
            onClick={onClose}
          >
            <span className='fs-5'>اعلانات</span>
          </div>
          <div
            className='btn btn-sm btn-icon btn-active-color-primary'
            onClick={onClose}
          >
            <KTIcon iconName='cross' className='fs-1' />
          </div>
 
        </div>

        <div className='modal-body scroll-y mx-1'>
          <NotificationListModal onClose={onClose}/>
        </div>
      </div>
    </Modal>
  )
}

export { NotificationsModal }
